import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { injectEnvironment } from 'planning-portal-library/src/lib/core/environments/environment.token';
import { catchError, map, mergeMap, Observable, reduce } from 'rxjs';
import {
  GetGridHeadersRequest,
  GridHeader,
  UpdateGridHeadersRequest,
} from '../../../../core/domain';
import { GridHeadersRepository } from '../../../../core/repositories';
import { BaseRequest } from '../../../shared/base.request';
import { BaseResponse } from '../../../shared/base.response';
import {
  isBlobError,
  parseErrorBlob,
} from '../../../shared/helpers/blob.helper';
import { GridHeaderWebRepositoryMapper } from './grid-header-web-repository-mapper';
import { GridHeadersApiUrls } from './grid-headers-api-urls';

@Injectable({ providedIn: 'root' })
export class GridHeadersWebRepository extends GridHeadersRepository {
  private readonly gridHeadersMapper = new GridHeaderWebRepositoryMapper();
  private readonly environment = injectEnvironment();

  constructor(private readonly http: HttpClient) {
    super();
  }

  getGridHeaders(
    request: BaseRequest<GetGridHeadersRequest>
  ): Observable<GridHeader[]> {
    const httpMap = this.http.post<BaseResponse<GridHeader[]>>(
      `${this.environment.url}${GridHeadersApiUrls.GetConfigurations}`,
      request.request
    );

    return httpMap
      .pipe(
        mergeMap((response) => response.result!),
        catchError((err) => {
          throw err;
        })
      )
      .pipe(map(this.gridHeadersMapper.mapFrom))
      .pipe(
        reduce((items: GridHeader[], item: GridHeader) => [...items, item], [])
      );
  }

  updateGridHeaders(
    request:
      | BaseRequest<UpdateGridHeadersRequest[]>
      | BaseRequest<UpdateGridHeadersRequest>
  ): Observable<boolean> {
    return this.http
      .post<BaseResponse<unknown>>(
        `${this.environment.url}${GridHeadersApiUrls.UpdateConfigurations}`,
        request.request
      )
      .pipe(
        map((data) => {
          return data.successful;
        }),
        catchError((err) => {
          throw err;
        })
      );
  }

  getSampleNetworkFiles(): Observable<HttpResponse<Blob>> {
    return this.http
      .get(
        `${this.environment.url}${GridHeadersApiUrls.GetNetworkSampleFiles}`,
        {
          responseType: 'blob',
          observe: 'response',
        }
      )
      .pipe(
        catchError((err) => {
          if (isBlobError(err)) {
            return parseErrorBlob(err);
          }
          throw err;
        })
      );
  }
  getSampleJLUploadFiles(): Observable<HttpResponse<Blob>> {
    return this.http
      .get(
        `${this.environment.url}${GridHeadersApiUrls.GetJLUploadSampleFile}`,
        {
          responseType: 'blob',
          observe: 'response',
        }
      )
      .pipe(
        catchError((err) => {
          if (isBlobError(err)) {
            return parseErrorBlob(err);
          }
          throw err;
        })
      );
  }
  getSampleLocationFile(): Observable<HttpResponse<Blob>> {
    return this.http
      .get(
        `${this.environment.url}${GridHeadersApiUrls.GetLocationSampleFile}`,
        {
          responseType: 'blob',
          observe: 'response',
        }
      )
      .pipe(
        catchError((err) => {
          if (isBlobError(err)) {
            return parseErrorBlob(err);
          }
          throw err;
        })
      );
  }
}
